import layout from '@/layout'

export default {
  path: '/winner',
  component: layout,
  redirect: '/winner/overview',
  name: 'winner_overview',
  meta: {
    title: 'winner',
    icon: 'winner'
  },
  children: [
    {
      path: '/winner/overview',
      name: 'winner_overview',
      component: () => import('@/views/winner/pages/overview/index.vue'),
      meta: {
        title: 'winner_overview',
        icon: 'bang'
      }
    }
  ]
}
